import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import WhatsAppButton from '@/components/feature/WhatsAppButton';
import HeroSection from './components/HeroSection';
import StatsBar from './components/StatsBar';
import ServicesPreview from './components/ServicesPreview';
import ProjectsReel from './components/ProjectsReel';
import CorporateCapabilities from './components/CorporateCapabilities';
import ClientsSection from './components/ClientsSection';
import WhyUs from './components/WhyUs';
import Testimonials from './components/Testimonials';
import CtaBanner from './components/CtaBanner';
import ContactSection from './components/ContactSection';

const HomePage = () => {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <StatsBar />
        <ServicesPreview />
        <ProjectsReel />
        <CorporateCapabilities />
        <ClientsSection />
        <WhyUs />
        <Testimonials />
        <CtaBanner />
        <ContactSection />
      </main>

      {/* Social Media */}
      <section className="py-16 bg-white">
        <div className="max-w-3xl mx-auto px-4 md:px-8 text-center">
          <span className="text-[#C88A2A] text-sm font-bold uppercase tracking-widest">Síguenos</span>
          <h2 className="text-2xl md:text-3xl font-black text-[#0C1D2E] mt-2 mb-3">
            Conecta con nosotros
          </h2>
          <p className="text-[#475569] text-base mb-8">
            Sigue nuestras obras y proyectos en redes sociales. Compartimos fotos, videos y novedades de IngemetalSur.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="https://www.instagram.com/ingemetalsurtco"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="inline-flex items-center justify-center gap-3 bg-gradient-to-r from-purple-600 via-pink-500 to-orange-400 hover:opacity-90 text-white font-bold px-8 py-4 rounded-md transition-opacity duration-200 whitespace-nowrap text-base"
            >
              <i className="ri-instagram-line text-xl"></i>
              Instagram
            </a>
            <a
              href="https://www.facebook.com/ingemetalsur"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="inline-flex items-center justify-center gap-3 bg-[#1877F2] hover:bg-[#166fe5] text-white font-bold px-8 py-4 rounded-md transition-colors duration-200 whitespace-nowrap text-base"
            >
              <i className="ri-facebook-circle-line text-xl"></i>
              Facebook
            </a>
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
    </>
  );
};

export default HomePage;